require('./assets/scss/app-artist.scss');
require('./assets/js/app');